<template>
	<div class="vso-profile-progress-wrapper">
		<design-2021-user-profile-credentials-expanded-component
			:user-credentials-in="userCredentialsIn"
			:teacher-access="teacherAccess">
		</design-2021-user-profile-credentials-expanded-component>

		<design-2021-combined-personal-goals-skills-component
			:personal-goals-in="personalGoalsIn"
			:teacher-access="teacherAccess"
			:skill-trees-in="skillTreesIn"
			:vso-skill-tree-in="vsoSkillTreeIn"
			:seasons-in="seasonsIn"
			:user-credentials-in="userCredentialsIn"
			:gradable-moments-in="gradableMomentsIn"
			:student-evaluations-in="studentEvaluationsIn">
		</design-2021-combined-personal-goals-skills-component>
	</div>
</template>

<script>
	export default {
		name: 'design-2021-vso-profile-progress-component',
		props: {
			teacherAccess: {
				type: Boolean,
				default: () => {
					return false;
				},
			},
			userCredentialsIn: {
				type: Object,
				required: true,
			},
			timelineItemsIn: {
				type: Array,
				required: true,
			},
			categoriesIn: {
				type: Array,
				required: true,
			},
			seasonsIn: {
				type: Array,
				required: true,
			},
			personalGoalsIn: {
				type: Array,
				required: true,
			},
			skillTreesIn: {
				type: Array,
				required: true,
			},
			vsoSkillTreeIn: {
				type: Object,
				required: false,
			},
			gradableMomentsIn: {
				type: Array,
				required: false,
				default: [],
			},
			studentEvaluationsIn: {
				type: Array,
				required: false,
				default: [],
			},
		},
	};
</script>

<style scoped lang="scss"></style>
